import { Component, OnInit, Input, Output, OnDestroy, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common/common.service";
import { Constant, ContentTypeValues, SolrContentTypeValues } from "../../../common/constant/constant";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { RepairOrderService } from "src/app/services/repair-order/repair-order.service";
import { BaseService } from "src/app/modules/base/base.service";
import { Title } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { KnowledgeArticleService } from "src/app/services/knowledge-article/knowledge-article.service";
import { ApiService } from 'src/app/services/api/api.service';
import { ConfirmationComponent } from '../../../components/common/confirmation/confirmation.component';
import { RepairOrderDetailViewComponent } from "src/app/components/common/repair-order-detail-view/repair-order-detail-view.component";
import { Message,MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { stat } from "fs";

@Component({
  selector: 'app-view-ro-detail',
  templateUrl: './view-ro-detail.component.html',
  styleUrls: ['./view-ro-detail.component.scss'],
  providers: [MessageService]
})
export class ViewRoDetailComponent implements OnInit, OnDestroy {
  @ViewChild('top',{static: false}) top: ElementRef;
  @Input() repairOrderId;
  @Input() isComeFromFinnacialsList;
  @Input() fromDispatch: boolean = false;
  @Output() KAServices: EventEmitter<any> = new EventEmitter();
  @Output() roActionEmit: EventEmitter<any> = new EventEmitter();
  roDetailViewRef: RepairOrderDetailViewComponent;
  public sconfig: PerfectScrollbarConfigInterface = {};
  public bodyClass: string = "thread-detail";
  public bodyClass1: string = "landing-page";
  public bodyElem;
  public title: string = "Repair Order Details";
  public user: any;
  public roleId;
  public platformId: number = 0;
  public domainId;
  public userId;
  public countryId;
  public navUrl: string = "";
  public action = "view";
  public contentType:any = ContentTypeValues.RepairOrder;
  public industryType: any = "";
  public innerHeight: number;
  public bodyHeight: number; 
  public modalConfig: any = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };
  public roFlag: boolean = true;
  public calproFlag: boolean = false;
  public removeReportFlag: boolean = false;
  public previewPopupFlag: boolean = false;
  public endUser: boolean = false;
  public loading: boolean = true;
  public successMsg: string = "";
  public copiedModal: boolean = false;
  public viewDocument: boolean = true;
  public repairOrderEditFlag: boolean = false;
  public repairOrderDeleteFlag: boolean = false;
  public threadOwnerAccess: boolean = false;
  public repairOrderApproveFlag: boolean = false;
  public noSupportVisible: boolean = false;
  public noSupportFlag: boolean = false;
  public enableSupportFlag: boolean = false;
  public diagnationDomain: boolean = false;
  public isCustomerActive: boolean = false; 
  public roTimeMotionFlag: boolean = false;
  public roLogFlag: boolean = false;
  public roID: string = '';
  public threadId: any = 0;
  public newPage: string = '0';
  public approveButton: boolean = false;
  public actionType: any = SolrContentTypeValues.repairOrder;
  public systemMsg: Message[];
  public isEditDeleteButtonVisible: boolean = true;
  public roStatusData: any = [];
  public roEstimatePreview: boolean = false;
  public generateInvoiceFlag: boolean = false;
  public roInvoicePreview: boolean = false;
  public baseV3ApiUrl: string = "";
  public supportTicketPath: string = "support-tickets";
  public previewUrl: string = "";
  public detailCallbackData: any = [];
  public invoiceEstId: any = 0;

  constructor(
    private titleService: Title,    
    private router: Router,
    private commonApi: CommonService,
    private authenticationService: AuthenticationService,
    private repairOrderApi: RepairOrderService,
    private baseService: BaseService,
    private knowledgeArticleService: KnowledgeArticleService,
    private modalService: NgbModal,
    public apiUrl: ApiService,
    public messageService: MessageService,
    private primengConfig: PrimeNGConfig,
  ) { }

  ngOnInit(): void {
    this.bodyElem = document.getElementsByTagName('body')[0];
    if (this.isComeFromFinnacialsList) {
      this.isEditDeleteButtonVisible = false;
    } else {
      this.isEditDeleteButtonVisible = true;
    }

    if(!document.body.classList.contains(this.bodyClass)) {
      document.body.classList.add(this.bodyClass);
    }

    if(!document.body.classList.contains(this.bodyClass1)) {
      document.body.classList.add(this.bodyClass1);
    }

    if(!document.body.classList.contains('view-modal-popup')) {
      document.body.classList.add('view-modal-popup');
    }

    if(!document.body.classList.contains('view-modal-popup-manage')) {
      document.body.classList.add('view-modal-popup-manage');
    }

    this.industryType = this.commonApi.getIndustryType();
    //this.title = `${this.title}${this.knowledgeArticleId}`;
    let getParams:any = localStorage.getItem('param');
    getParams = (getParams && getParams != 'undefined') ? JSON.parse(getParams) : '';
    if(getParams != '') {
      let contItems = getParams.items;
      let cindex = contItems.findIndex(option => option.contentTypeId == this.contentType);
      if(cindex >= 0) {
        this.title = contItems[cindex].name;
      }
    }
    if(!this.fromDispatch) {
      //this.titleService.setTitle( localStorage.getItem('platformName')+' - '+this.title);
    }
    let navUrl = (this.title == 'Repair Order') ? 'repair-order' : 'support-request';
    this.navUrl =  `${navUrl}/view/${this.repairOrderId}`;
    this.roID = this.repairOrderId;

    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;
    this.endUser = (this.roleId == 4) ? true : false;
    this.countryId = localStorage.getItem('countryId');
    this.baseV3ApiUrl = this.apiUrl.apiCollabticV3BaseUrl();

    switch(this.domainId) {
      case 343:
      case 338:
        this.noSupportVisible = false;
        this.diagnationDomain = (this.domainId == 338) ? true : false;
        break;
      default:
        this.noSupportVisible = true;
        break;  
    }

    this.setScreenHeight();
  }

   // Set Screen Height
   setScreenHeight() {  
    this.bodyHeight = window.innerHeight;  
    this.innerHeight = (this.bodyHeight - 87 );  
  } 

  threadHeaderAction(event) {
    this.checkAccess(event);
  }

  checkAccess(type){
    switch(type){
      case 'edit':
        this.edit();
        break;
      case 'approve':
      case 'complete':
      case 'order-detail':
      case 'delete':
        if(type == 'approve'){
          this.repairOrderApproveFlag = false;
        }
        let data = {
          action: type,
          id: this.repairOrderId      
        }
        this.commonApi.emitRODetailData(data);
        break;
      case 'copylink':
        let currentURL1 = window.location.href;
        let currentURL2 = this.router.url;
        let currentURL3 = currentURL1.replace(currentURL2,"")
        console.log(currentURL3);
        let url = `${currentURL3}/${this.navUrl}`;
        navigator.clipboard.writeText(url);
        this.copiedModal = true;
        setTimeout(() => {
          this.copiedModal = false;
        }, 1500);
        break;
      default:
        break;
    }
  }

  closeModal() {
    let data = {
      action: false
    };
    this.KAServices.emit(data);
  }

  popupClose(event){
    let action = event['action'];
    switch (action){
      case 'close':
        let data = {
          action: 'delete',
          id: this.repairOrderId
        }
        this.KAServices.emit(data);
      break;
      case 'access':
        this.threadOwnerAccess = event['threadOwnerAccess'];
        this.repairOrderEditFlag = event['editAccess'];
        this.repairOrderDeleteFlag = event['deleteAccess'];
        this.repairOrderApproveFlag = (!this.noSupportVisible) ? event['approveBtnEnable'] : this.approveButton; 
      break;
      default:
      break;
    }
  }

  //edit document
  edit(){      
    this.closeModal();
    setTimeout(() => {
      var data = {
        action : 'edit',
        id: this.repairOrderId
      }
      this.commonApi.updateROData(data);
    }, 100);
  }

  detailCallback(data) {
    let action = data.action;
    let endUser = data.endUser;
    let setupEstAction = true;
    console.log(data)
    if(data?.roData) {
      this.roDetailViewRef = data;
      this.roTimeMotionFlag = data.roTimeMotionFlag;
      this.roLogFlag = data.roLogFlag;
      let roData = data.roData;
      this.roFlag = roData.roFlag;
      if(data?.roData?.roCalproAdasFlag && data?.roData?.roCalproAdasFlag != undefined) {        
        this.calproFlag = roData.roCalproAdasFlag;        
        if(this.calproFlag) {
          let roViewData = roData.ROViewData;
          this.removeReportFlag = (roViewData.adasReportIdInt > 0) ? true : false;
        }
      } else {
        this.calproFlag = false;
        this.removeReportFlag = false;
      }
    }
    switch (action) {
      case 'no-support':
        setupEstAction = false;
        let threadId = data.threadId;
        let fromPublic = data.fromPublic;
        this.threadId = threadId;
        let status = parseInt(data.workOrderStatus);
        this.roStatusData = data.roStatusData;
        let approveAction = (data?.approveAction && data?.approveAction != undefined) ? data?.approveAction : false;
        if(this.endUser) {
          if(this.domainId == 507 && (status == 1 || status == 12 || status == 14)) {
            let statusName = '';
            switch(status) {
              case 1:
                statusName = 'RO Sent';
                break;
              case 12:
                statusName = 'Invoice';
                break;
              case 14:
                statusName = 'Estimate';
                break;  
            }
            this.roStatusData[0]['statusName'] = statusName;
          }
          if(status == 15 && approveAction) {
            let emitAction = 'refresh-ro';
            let data = {
              action: emitAction,
              repairOrderId: this.repairOrderId
            };
            this.KAServices.emit(data);            
          }
        }

        this.loading = false;
        if(this.noSupportVisible) {
          this.noSupportFlag = ((!fromPublic && fromPublic != 'undefined') || endUser || threadId > 0 || status > 11) ? false : true;
          this.enableSupportFlag = (status == 16 && !endUser) ? true : false;
          this.repairOrderApproveFlag = (status == 16) ? false : this.repairOrderApproveFlag;
          this.approveButton = ((threadId == 0 || status == 1) && status != 16) ? true : false;          
        }
        this.isCustomerActive = (data.isCustomerActiveInt == 0) ? false : true;
        break;
      case 'estimate':
        let wstatus = parseInt(data.workOrderStatus);
        if(wstatus == 14) {
          let data = {
            action,
            repairOrderId: this.repairOrderId
          };
          this.KAServices.emit(data);            
        }
        break;
      case 'invoice':
        let rwstatus = parseInt(data.workOrderStatus);
        if(rwstatus == 12) {
          let data = {
            action,
            repairOrderId: this.repairOrderId
          };
          this.KAServices.emit(data);            
        }
        break;  
      case 'preview-open':
        setupEstAction = false;
        this.previewPopupFlag = true;
        break;
      case 'preview-close':
        setupEstAction = false;
        this.previewPopupFlag = false
        break;  
      case 'invoice-menu':
        setTimeout(() => {
          this.top.nativeElement.scrollTop=0;
        }, 1200);
        break;
      case 'refresh-ro':
        let refreshData = {
          action,
          repairOrderId: this.repairOrderId
        };
        this.KAServices.emit(refreshData);
        break;   
      default:
        break;
    }
    //let emitAction = (data.)
    if(setupEstAction) {
      this.setupEstAction(data);
    }
  }

  changeRepairOrderStatus(status) {
    let fromThread:any = 1;
    let platform: any = 3;
    this.noSupportFlag = false;
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);               
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('id', this.roID);          
    apiDatasocial.append('statusId', status);
    apiDatasocial.append('fromThread', fromThread);
    apiDatasocial.append('platform', platform);
    this.repairOrderApi.changeStatusTicket(apiDatasocial).subscribe(res => {
      this.enableSupportFlag = true;
      this.systemMsg = [{severity:'success', summary:'', detail:res.message}];
      this.primengConfig.ripple = true;
      setTimeout(() => {
        this.systemMsg = [];
      }, 3000);
      let action = 'update';
      this.updateROSolr(this.roID, action);
    });
  }

  updateROSolr(id, action) {
    let apiDatasocial1 = new FormData();    
    apiDatasocial1.append('apiKey', Constant.ApiKey);
    apiDatasocial1.append('domainId', this.domainId);
    apiDatasocial1.append('workOrderId', id);
    apiDatasocial1.append('userId', this.userId); 
    apiDatasocial1.append('action', action); 
    apiDatasocial1.append('actionType', this.actionType);
    this.baseService.postFormData("forum", "UpdateDatetoSolr", apiDatasocial1).subscribe((response: any) => { }); 
  }

  generateinvoice() {
    this.detailCallbackData.estimateListRef.invoiceAction('generate-invoice');
    setTimeout(() => {
      this.roInvoicePreview = true;
    }, 1500);
  }

  print() {
    let aurl = this.previewUrl;
    let navPreviewPdf = window.open(aurl, aurl);
    navPreviewPdf.focus();
  }

  setupEstAction(data) {
    console.log(data)
    let roData = data.roData;
    this.detailCallbackData = roData;
    let estimateRef = roData.estimateListRef;
    this.roEstimatePreview = false;
    this.generateInvoiceFlag = false;
    this.roInvoicePreview = false;
    let previewFlag = false;
    this.previewUrl = "";
    let estPath = 'estimate-pdf';
    let estId = (data?.estId && data?.estId != undefined) ? data.estId : 0;
    let access = '';
    let previewUrl = `${this.baseV3ApiUrl}/${this.supportTicketPath}/${estPath}?id=${this.repairOrderId}&eid=`;
    if(roData.roEstimateFlag && !estimateRef?.estimateItemEmpty) {
      if(estId > 0) {
        this.roEstimatePreview = true;
        this.generateInvoiceFlag = true;
      } else {
        estId = (roData.estimateData && roData.estimateData != undefined && roData.estimateData?.length > 0) ? roData.estimateData[0].estId : estId;
        if(estId == 0) {
          estId = (roData.estimateInfo && roData.estimateInfo != undefined && roData.estimateInfo?.length > 0) ? roData.estimateInfo[0].estimateId : estId;
          this.roEstimatePreview = (estId > 0) ? true : false;
          this.generateInvoiceFlag = (estId > 0) ? true : false;
        } else {
          this.roEstimatePreview = (roData.estimateData?.length > 0) ? true : this.roEstimatePreview;
          this.generateInvoiceFlag = (roData.estimateData?.length > 0) ? true : this.generateInvoiceFlag;
        }
      }            
      previewFlag = (estId > 0) ? true : false;
    }
    if(roData.roInvoiceFlag) {
      access = '&access=invoice';
      if(estId > 0) {
        this.invoiceEstId = estId;
        this.roInvoicePreview = true;
      } else {
        estId = (roData.invoiceData && roData.ROViewData.invoiceInfoDataJsonArr != undefined) ? roData.ROViewData.invoiceInfoDataJsonArr[0].estId : estId;
        this.roInvoicePreview = (roData.invoiceCount > 0) ? true : this.roInvoicePreview;
      }
      estId = (estId == 0) ? this.invoiceEstId : estId;
      this.roInvoicePreview = (estId > 0) ? true : this.roInvoicePreview;
      previewFlag = (estId > 0) ? true : false;
    }
    if(previewFlag && estId > 0) {
      this.previewUrl = `${previewUrl}${estId}${access}`;
    }
  }

  removeReport() {
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
      modalRef.componentInstance.access = 'removeDelete';
      modalRef.componentInstance.confirmAction.subscribe((recivedService) => {
        modalRef.dismiss('Cross click');
        console.log(recivedService);
        if(!recivedService) {
          return;
        } else {
          this.removeAdasReport();
        }
      });
  }

  removeAdasReport() {
    let action = 'remove';
    let roView:any = this.roDetailViewRef['roData'];
    let roData = roView.ROViewData;
    roData.adasReportIdInt = 0;
    this.removeReportFlag = false;
    let calproRef = roView.calproReportRef;
    let adasReportId = calproRef.reportId;
    calproRef.removeLoading = true;
    console.log(roView, roData, adasReportId);
    calproRef.calproReportAction(action, adasReportId);    
  }

  ngOnDestroy() {
    this.bodyElem = document.getElementsByTagName('body')[0];
    let navItem = `thread-ro-${this.threadId}-nav-${this.roID}`;
    let checkNavItem = localStorage.getItem(navItem);
    checkNavItem = (checkNavItem && checkNavItem != undefined) ? checkNavItem : '';
    if(checkNavItem == '') {      
      this.bodyElem.classList.remove("thread-detail");
    } else {
      localStorage.removeItem(navItem);
      this.bodyElem.classList.remove("view-modal-popup-thread");
    }
    this.bodyElem.classList.remove("view-modal-popup");
  }
    
}